const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Auto-apply discount code (Pakistan time). SOLES500 through 12 Oct 2026, SOLES250 from 13 Oct 2026 onward. */
(function () {
  try {
    var day = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Karachi', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    var code = day <= '2026-10-12' ? 'SOLES500' : 'SOLES250';
    var key = 'soles_auto_disc';
    var done = null;
    try { done = localStorage.getItem(key); } catch (e) {}
    var stamp = code + '|' + day;
    if (done === stamp) return;
    fetch('/discount/' + code, { credentials: 'same-origin', redirect: 'manual' })
      .then(function () { try { localStorage.setItem(key, stamp); } catch (e) {} })
      .catch(function () {});
  } catch (e) {}
})();
